import { render, staticRenderFns } from "./OrderProofReviewHeader.vue?vue&type=template&id=5da57760"
import script from "./OrderProofReviewHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProofReviewHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports